module.exports = "/fonts/vendor/@fontsource/inter/files/inter-all-700-normal.woff?76d6018ed1d9194ab6e6bf7a231f6f1d";